import {Link, Text} from '@primer/react-brand/esm'

import {ContentfulDownloadActionMenu} from '@github-ui/swp-core/components/contentful/ContentfulDownloadActionMenu'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {isLink} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'

import type {GenericCtaAction} from '../../../../brand/lib/types/contentful'

type Props = {
  action: GenericCtaAction
  location: string
}

export function CustomerStoriesCtaAction({action, location}: Props) {
  if (!isLink(action)) {
    return (
      <ContentfulDownloadActionMenu
        component={action}
        analytics={{tag: 'link', context: 'footer', location}}
        variant="secondary"
      />
    )
  }

  return (
    <Link
      variant="accent"
      /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
      className="lp-CustomerStories-link"
      href={action.fields.href}
      {...getAnalyticsEvent({
        action: action.fields.text,
        tag: 'link',
        context: 'footer',
        location,
      })}
    >
      <Text weight="normal" size="300">
        {action.fields.text}
      </Text>
    </Link>
  )
}
